import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-launch-prompt-dialog',
  templateUrl: './app-launch-prompt-dialog.component.html',
  styleUrl: './app-launch-prompt-dialog.component.scss',
})
export class AppLaunchPromptDialogComponent {
  constructor(public dialogRef: MatDialogRef<AppLaunchPromptDialogComponent>) { }

  continueInBrowser(): void {
    this.dialogRef.close('browser');
  }

  openInApp(): void {
    this.dialogRef.close('app');
  }
}
